// extracted by mini-css-extract-plugin
var _1 = "ProfileAISummaryWidgetContent-moduleProfileAISummaryWidgetContentText__TdGpa";
var _2 = "ProfileAISummaryWidgetContent-modulecopyableContent__JTdje";
var _3 = "ProfileAISummaryWidgetContent-modulefilesList__Vs2YP";
var _4 = "ProfileAISummaryWidgetContent-modulesummaryText__sGDY2";
var _5 = "ProfileAISummaryWidgetContent-moduletitle__bLblB";
var _6 = "ProfileAISummaryWidgetContent-modulewarningText__uIISj";
export { _1 as "ProfileAISummaryWidgetContentText", _2 as "copyableContent", _3 as "filesList", _4 as "summaryText", _5 as "title", _6 as "warningText" }
